"use client"

import { ElementType, ReactNode } from "react";
import { toast } from "sonner";

function CopyContent({ as, copy, children, ...props }:
    { as: ElementType, copy: string, onClick?: undefined, children?: ReactNode, [key: string]: any }) {
    const DynComponent = as;
    return <DynComponent {...props}
        onClick={async () => {
            const toastID = toast.loading("מחכה לאישור גישה ללוח העתק-הדבק..");
            try {
                await navigator.clipboard.writeText(copy);
                toast.info("הועתק ללוח!")
            } catch (e) {
                toast.error("לא ניתן להעתיק ללוח..")
            } finally {
                toast.dismiss(toastID)
            }
        }}
    >{children}</DynComponent>
}
export default CopyContent